<template>
  <InputSuajeDrawer
    v-if="admiteSuaje"
    :visible="mostrarDrawerSuaje"
    :filtros="filtrosSuaje"
    :adaptadores="false"
    @cerrar-buscar-suaje="mostrarDrawerSuaje = false"
    @seleccionar-suaje="handleSeleccionarSuaje"
  />

  <div
    v-bind="$attrs"
    class="border-b-2 border-solid border-x-0 border-t-0 border-gray-300 draggable-item"
    :class="{ 'is-deleted': localModel.MarcadoParaEliminacion }"
    :draggable="isDraggableActive && !localModel.MarcadoParaEliminacion"
    :data-index="index"
    :data-zone-id="zoneId"
    style="position: relative"
    @dragstart="handleDragStart"
    @dragend="handleDragEnd"
  >
    <div
      v-if="localModel.MarcadoParaEliminacion"
      class="deleted-overlay"
    >
      <div class="deleted-content">
        <span class="deleted-text">🚫 Proceso eliminado</span>
        <el-button
          type="info"
          plain
          size="small"
          @click="undoDelete"
          >Deshacer</el-button
        >
      </div>
    </div>

    <div
      class="flex"
      :class="{ 'opacity-40 pointer-events-none': localModel.MarcadoParaEliminacion }"
    >
      <div
        class="draggable-item-setion"
        @mousedown="startDragActivation"
        @mouseup="cancelDragActivation"
      >
        <IconDragVertical />
      </div>
      <el-col :span="23">
        <el-row
          :gutter="20"
          style="margin-bottom: 5px"
          class="row-proceso"
        >
          <custom-select
            v-model="localModel.Proceso"
            :label="''"
            :span="4"
            :settings="{
              filterable: true,
              options: procesos,
              inputClass: 'ancho_total',
            }"
            class="w-120"
          />
          <custom-switch
            v-if="localModel.Proceso?.Recurso"
            v-model="localModel.FueraDeLinea"
            :spanColumn="2"
            :label="etiquetasProceso.FueraDeLinea || 'Fuera de Línea'"
            :settings="{
              disabled: false,
            }"
            class="w-70"
          />
          <!-- COTI-642: marca el proceso como raíz del flujo (sin precedente por orden). El
               primero de la lista es siempre inicial y no se puede desmarcar. No se muestra
               en procesos informativos (marcadores no productivos, p. ej. PRODUCTO TERMINADO). -->
          <custom-switch
            v-if="localModel.Proceso && !localModel.Proceso.EsInformativo"
            :model-value="esPrimerProceso || !!localModel.EsProcesoInicial"
            :spanColumn="2"
            :label="'Proceso inicial'"
            :settings="{
              disabled: esPrimerProceso,
            }"
            class="w-70"
            @update:model-value="(v) => (localModel.EsProcesoInicial = v)"
          />
          <custom-input-number
            v-if="shouldShowPorcentaje"
            v-model="localModel.Porcentaje"
            :spanColumn="2"
            :label="'Porcentaje'"
            :settings="{
              placeholder: '%',
              min: 0,
              max: 100,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
            :class="{ 'error-porcentaje': porcentajeExcedido }"
            class="w-70"
          />
          <custom-input-number
            v-if="localModel?.Proceso?.Cantidad || false"
            v-model="localModel.Cantidad"
            :spanColumn="2"
            :label="etiquetasProceso.Cantidad || 'Cantidad'"
            :settings="{
              placeholder: etiquetasProceso.Cantidad || 'Cantidad',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="deberMostrarCamposBocas || localModel?.Proceso?.BocasAncho || false"
            v-model="localModel.BocasAncho"
            :spanColumn="2"
            :label="etiquetasProceso.BocasAncho || 'BocasAncho'"
            :settings="{
              placeholder: etiquetasProceso.BocasAncho || 'BocasAncho',
              min: 0,
              precision: 0,
              step: 1,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.BocasAnchoFinales || false"
            v-model="localModel.BocasAnchoFinales"
            :spanColumn="2"
            :label="etiquetasProceso.BocasAnchoFinales || 'Bocas Ancho Finales'"
            :settings="{
              placeholder: etiquetasProceso.BocasAnchoFinales || 'Bocas Ancho Finales',
              min: 1,
              precision: 0,
              step: 1,
              controls: true,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="deberMostrarCamposBocas || localModel?.Proceso?.BocasLargo || false"
            v-model="localModel.BocasLargo"
            :spanColumn="2"
            :label="etiquetasProceso.BocasLargo || 'BocasLargo'"
            :settings="{
              placeholder: etiquetasProceso.BocasLargo || 'BocasLargo',
              min: 0,
              precision: 0,
              step: 1,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.BocasAlto || false"
            v-model="localModel.BocasAlto"
            :spanColumn="2"
            :label="etiquetasProceso.BocasAlto || 'BocasAlto'"
            :settings="{
              placeholder: etiquetasProceso.BocasAlto || 'BocasAlto',
              min: 0,
              precision: 0,
              step: 1,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel.Proceso?.Costo"
            v-model="localModel.Costo"
            :spanColumn="2"
            :label="etiquetasProceso.Costo || 'Costo'"
            :settings="{
              placeholder: etiquetasProceso.Costo || 'Costo',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.DimensionAncho || false"
            v-model="localModel.DimensionAncho"
            :spanColumn="2"
            :label="etiquetasProceso.DimensionAncho || 'Ancho'"
            :settings="{
              placeholder: etiquetasProceso.DimensionAncho || 'Ancho',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.DimensionAlto || false"
            v-model="localModel.DimensionAlto"
            :spanColumn="2"
            :label="etiquetasProceso.DimensionAlto || 'Alto'"
            :settings="{
              placeholder: etiquetasProceso.DimensionAlto || 'Alto',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.Espesor || false"
            v-model="localModel.Espesor"
            :spanColumn="2"
            :label="etiquetasProceso.Espesor || 'Espesor'"
            :settings="{
              placeholder: etiquetasProceso.Espesor || 'Espesor',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.Gramaje || false"
            v-model="localModel.Gramaje"
            :spanColumn="2"
            :label="etiquetasProceso.Gramaje || 'Gramaje'"
            :settings="{
              placeholder: etiquetasProceso.Gramaje || 'Gramaje',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.Velocidad || false"
            v-model="localModel.Velocidad"
            :spanColumn="2"
            :label="etiquetasProceso.Velocidad || 'Velocidad'"
            :settings="{
              placeholder: etiquetasProceso.Velocidad || 'Velocidad',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.VelocidadManual || false"
            v-model="localModel.VelocidadManual"
            :spanColumn="3"
            :label="etiquetasProceso.VelocidadManual || 'Velocidad manual'"
            :settings="{
              placeholder: etiquetasProceso.VelocidadManual || 'Velocidad manual',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
              tooltip:
                'Si se completa con un valor mayor a 0, se usa en lugar de la velocidad configurada en la máquina para este proceso.',
            }"
            class="w-70"
          />

          <custom-input-number
            v-if="localModel?.Proceso?.PorcentajeMerma || false"
            v-model="localModel.PorcentajeMerma"
            :spanColumn="2"
            :label="etiquetasProceso.PorcentajeMerma || '% Merma'"
            :settings="{
              placeholder: etiquetasProceso.PorcentajeMerma || '% Merma',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
            class="w-70"
          />

          <custom-switch
            v-if="localModel.Proceso?.Adicional"
            v-model="localModel.Adicional"
            :spanColumn="2"
            :label="etiquetasProceso.Adicional || 'Adicional'"
            :settings="{
              disabled: false,
            }"
            class="w-70"
          />
          <div
            v-if="localModel.Proceso?.Adicional && habilitarNuevaGrillaCostos && esCotizacion"
            class="text-xs text-[var(--el-text-color-secondary)]"
          >
            También podés marcarlo como adicional desde la grilla de costos.
          </div>

          <el-col
            v-if="localModel.Proceso?.SentidoBobinado"
            :span="8"
          >
            <custom-select-sentido-bobinado
              v-model="localModel.CodigoSentidoBobinado"
              :label="etiquetasProceso.SentidoBobinado || 'Sentido de Bobinado'"
              :spanColumn="24"
            />
          </el-col>

          <el-col :span="1">
            <div class="label">&nbsp;</div>
            <div class="button-position">
              <el-button
                type="danger"
                size="small"
                :icon="IconDelete"
                @click="markAsDeleted"
              />
            </div>
          </el-col>
        </el-row>

        <ExtrusionProcesoForm
          v-if="IsProcesoExtrusion && localModel.Proceso"
          :model-value="{
            ExtrusionTipo: localModel.ExtrusionTipo,
            CantidadCapas: localModel.CantidadCapas,
            MaterialResultante: localModel.MaterialResultante,
            CodigoMaterialResultante: localModel.CodigoMaterialResultante,
            EspesorResultante: localModel.EspesorResultante,
            GramajeResultante: localModel.GramajeResultante,
            DensidadResultante: localModel.DensidadResultante,
          }"
          :is-option-disabled="isExtrusionTipoDisabled"
          :bobinas="localModel.ElementoProcesoBobinas || []"
          :densidad-resinas="densidadResinas"
          :tiene-formula-cargada="tieneFormulaCargada"
          @update:model-value="(val) => emit('update:modelValue', { ...localModel, ...val })"
          @replace-formula="onReemplazarFormula"
          @open-bobinas="bobinasModalVisible = true"
        />

        <input-maquina
          v-if="localModel.Proceso?.Recurso"
          v-model="maquinaModel"
          :proceso="localModel.Proceso"
          :recursos="recursos"
          :is-item-disabled="isMaquinaDisabled"
        />

        <el-alert
          v-if="recursoSeleccionadoIncompatible"
          type="warning"
          show-icon
          :closable="false"
          title="La máquina seleccionada no soporta la cantidad de capas o el tipo de extrusión configurados. Seleccione otra máquina o ajuste los valores."
          style="margin-top: 8px; margin-bottom: 8px"
        />

        <!-- COTI-633: el pliego no entra en la máquina seleccionada para este proceso. -->
        <el-alert
          v-if="errorMaximoMaquinaPliegoProceso"
          type="error"
          show-icon
          :closable="false"
          :title="errorMaximoMaquinaPliegoProceso"
          class="alerta-margenes-pliego"
          style="margin-top: 8px; margin-bottom: 8px"
        />

        <el-col
          v-if="admiteSuaje"
          :span="5"
        >
          <div class="label">&nbsp;</div>
          <el-button-group>
            <el-button
              type="primary"
              size="default"
              @click="mostrarDrawerSuaje = true"
            >
              Seleccionar Suaje
            </el-button>
            <el-button
              type="primary"
              size="default"
              disabled
            >
              {{ localModel.Suaje?.CodigoSuaje || localModel.CodigoSuaje || '-' }}
            </el-button>
            <el-button
              v-if="localModel.CodigoSuaje"
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="limpiarSuaje"
            />
          </el-button-group>
        </el-col>

        <div
          v-if="esProcesoTintas"
          class="mt-2"
        >
          <ProcesoColoresForm
            :model-value="localModel"
            :proceso="localModel.Proceso"
            :recurso="recursoSeleccionadoCompleto"
            @update:model-value="(val) => Object.assign(localModel, val)"
            @trigger-update-materials="handleGenerarTintas"
          />
        </div>

        <!-- Atributos Dinámicos del Proceso -->
        <div
          v-if="localModel.Proceso"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <ProcesoAtributosForm
            :model-value="localModel.AtributosAdicionales"
            :codigo-elemento-tipo="codigoElementoTipo"
            :codigo-proceso="localModel.Proceso?.Codigo"
            :modulo="Number(modulo) || null"
            :columns="3"
            layout="grid"
            @update:model-value="handleAtributosUpdate"
          />
        </div>

        <!-- Campos específicos de Extrusión -->
        <template v-if="IsProcesoExtrusion">
          <ExtrusionBobinasResumen
            v-if="localModel.Proceso"
            style="margin-top: 12px"
            :bobinas="localModel.ElementoProcesoBobinas || []"
            :factor-multiplicacion="factorMultiplicacion"
            :aprovechar-ancho-maximo="localModel.AprovecharAnchoMaximo ?? false"
            :recurso="recursoSeleccionadoCompleto"
          />

          <!-- Proporciones de Tornillos -->
          <div
            v-if="localModel.CantidadCapas > 0"
            style="margin-top: 20px"
          >
            <h4 style="margin-bottom: 12px; font-weight: 600">Proporciones por Tornillo</h4>

            <!-- Fila horizontal de proporciones -->
            <el-row
              :gutter="12"
              style="margin-bottom: 16px"
            >
              <el-col
                v-for="(tornillo, idx) in tornillosFila"
                :key="`prop-${idx}`"
                :span="4"
              >
                <div style="display: flex; align-items: center; gap: 8px">
                  <span style="font-weight: 500; min-width: 50px"
                    >Proporción T{{ idx + 1 }} (%):</span
                  >
                  <el-input-number
                    ref="inputRef"
                    :model-value="tornillo.Proporcion"
                    :min="0"
                    :max="100"
                    :precision="2"
                    :step="0.01"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    placeholder="0.00"
                    @focus="handleFocus"
                    @blur="handleBlur(tornillo.Proporcion)"
                    @update:model-value="(val) => actualizarTornillo(idx, 'Proporcion', val)"
                  />
                </div>
              </el-col>
            </el-row>

            <!-- Indicador total -->
            <div
              style="
                margin-bottom: 20px;
                padding: 10px;
                background: #f0f9ff;
                border-radius: 4px;
                border-left: 3px solid #409eff;
              "
            >
              <span style="font-weight: 500">Total de Proporción:</span>
              <span
                style="font-weight: bold; font-size: 16px; margin-left: 8px"
                :style="{ color: totalProporcionTornillos === 100 ? '#67c23a' : '#e6a23c' }"
              >
                {{ formatNumberLocale(totalProporcionTornillos, 2) }}%
              </span>
              <span
                v-if="totalProporcionTornillos === 100"
                style="color: #67c23a; margin-left: 10px"
                >✓ Válido</span
              >
              <span
                v-else
                style="color: #e6a23c; margin-left: 10px"
                >⚠️ Debe sumar 100%</span
              >
            </div>
          </div>
        </template>

        <div v-if="localModel.Proceso && localModel.Proceso.Material">
          <div
            v-if="alertaInconsistenciaRecurso"
            class="mb-2"
            style="margin-bottom: 10px"
          >
            <el-alert
              :title="alertaInconsistenciaRecurso.titulo"
              type="error"
              :description="alertaInconsistenciaRecurso.mensaje"
              show-icon
              :closable="false"
            />
          </div>

          <div v-if="localModel.Proceso && localModel.Proceso.Material">
            <div class="materials-fields">
              <div
                v-for="(categoria, indexCategoria) in localModel.CategoriasMaterial"
                :key="`categoria_material_${categoria.Codigo || indexCategoria}_${localModel.Proceso?.Codigo}`"
              >
                <template v-if="!shouldHideCategoria(categoria)">
                  <template v-if="categoria.Modulo">
                    <!-- <h3 style="margin-bottom: 5px; margin-top: 15px">{{ categoria.Descripcion }}</h3> -->
                    <input-materiales
                      v-model="localModel.CategoriasMaterial[indexCategoria]"
                      :validar-porcentaje="validarPorcentaje"
                      :proceso="localModel.Proceso"
                      :label-total-polimeros="labelTotalPolimeros"
                      :categoria="categoria"
                      :codigo-elemento-tipo="codigoElementoTipo"
                      :cantidad-capas="localModel.CantidadCapas || 1"
                      :procesos-del-elemento="procesosDelElemento"
                      :proceso-uid="localModel._uid"
                      :elemento-proceso-tornillos="localModel.ElementoProcesoTornillos || []"
                      :mostrar-materiales-reales="mostrarMaterialesReales"
                      :unidad-recurso="unidadRecurso"
                      :recurso-pendiente-recalculo="recursoPendienteRecalculo"
                      :max-cuerpos-impresores="maxCuerposImpresores"
                      :codigo-familia-material="CodigoFamiliaMaterial"
                      @update:ElementoProcesoTornillos="
                        (val) => (localModel.ElementoProcesoTornillos = val)
                      "
                    />
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
        <el-row
          v-if="localModel.Proceso?.Observaciones"
          :gutter="20"
          class="row-observaciones"
        >
          <el-col :span="24">
            <custom-input
              v-model="localModel.Observaciones"
              :spanColumn="24"
              :settings="{ placeholder: etiquetasProceso.Observaciones || 'Observaciones' }"
            />
          </el-col>
        </el-row>
      </el-col>
    </div>

    <ExtrusionBobinasModal
      v-if="IsProcesoExtrusion"
      v-model:visible="bobinasModalVisible"
      :factor-multiplicacion="factorMultiplicacion"
      :model-value="localModel.ElementoProcesoBobinas || []"
      :recurso="recursoSeleccionadoCompleto"
      :aprovechar-ancho-maximo="localModel.AprovecharAnchoMaximo ?? false"
      :permite-varias-bobinas="extrusionEsUnicoProceso"
      @save="
        ({ bobinas, aprovecharAnchoMaximo }) =>
          emit('update:modelValue', {
            ...localModel,
            ElementoProcesoBobinas: bobinas,
            AprovecharAnchoMaximo: aprovecharAnchoMaximo,
          })
      "
    />
  </div>
</template>

<script setup>
import {
  computed,
  ref,
  onMounted,
  onUnmounted,
  watch,
  inject,
  nextTick,
} from 'vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomSwitch from '@/shared/components/custom_switch.vue';
import IconDelete from '~icons/mdi/delete';
import InputMaquina from '@/shared/components/input_maquina.vue';
import CustomSelectSentidoBobinado from '@/shared/components/custom_select_sentido_bobinado.vue';
import InputMateriales from '@/shared/components/input_materiales.vue';
import ProcesoAtributosForm from '@/shared/components/atributos-dinamicos/ProcesoAtributosForm.vue';
import ProcesoColoresForm from './proceso_colores_form.vue';
import ExtrusionProcesoForm from './ExtrusionProcesoForm.vue';
import ExtrusionBobinasModal from './ExtrusionBobinasModal.vue';
import ExtrusionBobinasResumen from './ExtrusionBobinasResumen.vue';
import InputSuajeDrawer from '@/shared/components/suaje/input_suaje_drawer.vue';
import proceso_service from '@/services/proceso_service';
import { MaterialService } from '@/services/material_service';
import { MaterialCategoria } from '@/enum/material_categoria_enum.js';
import IconDragVertical from '~icons/mdi/drag-vertical';
import {
  getNextCuerpoImpresor,
  esRecursoImpresora,
} from '@/shared/composables/useCuerpoImpresor.js';
import { useErrorRegistro } from '@/shared/composables/use_error_registry.js';
import { calcularErrorMaximoMaquinaPliego } from '@/shared/utils/margenes_pliego_maquina.js';
import { calcularDensidadResinas } from '@/shared/utils/extrusion_densidad_resinas.js';
import {
  reasignarTipoTintaPorCambioDeProceso,
  reasignarTintaPorCambioDeProceso,
  reasignarBarnizPorCambioDeProceso,
  reasignarCoberturaPorCambioDeProceso,
  camposTintaPorDefecto,
} from '@/shared/utils/tipo_tinta_por_proceso.js';
import { resolverLabelsMatrizImpresion } from '@/shared/utils/label_matriz_impresion.js';
import { Modules } from '@/enum/modules.js';
import { storeToRefs } from 'pinia';
import { useConfiguracionStore } from '@/stores/configuracion-general.js';
import { useConfiguracionesPorDefectoStore } from '@/views/configuraciones_por_defecto/stores/configuraciones_por_defecto_store.js';
import { formatNumberLocale } from '@/shared/utils/locale_number_utils.js';
import { useLocaleNumberInput } from '@/shared/composables/useLocaleNumberInput.js';

const { inputRef, formatter, parser, handleFocus, handleBlur } = useLocaleNumberInput(2);

defineOptions({ inheritAttrs: false });

const props = defineProps({
  modelValue: { type: Object, required: true },
  // TODO: carcar modelo segun currentModule
  procesos: { type: Array, required: true },
  CodigoFamiliaMaterial: {
    type: Number,
    required: false,
  },
  validarPorcentaje: { type: Boolean, default: false },
  porcentajeExcedido: { type: Boolean, default: false },
  index: { type: Number, required: true },
  zoneId: { type: [String, Number], required: true },
  codigoElementoTipo: { type: Number, default: null },
  modulo: { type: Number, default: null },
  // COTI-642: bajan desde input_procesos.vue (respaldo del provide/inject).
  procesosDelElemento: { type: Array, default: null },
});

const emit = defineEmits(['update:modelValue', 'delete-proceso', 'drag-start', 'drag-end']);

const currentElementoBase = inject('currentElementoBase', null);
const isDraggingGlobal = inject('isDraggingGlobal', ref(false));

// COTI-642: provisto por input_procesos.vue. Se prioriza el prop (respaldo) y si no el inject.
const procesosDelElementoInject = inject(
  'procesosDelElemento',
  computed(() => []),
);
const procesosDelElemento = computed(() =>
  props.procesosDelElemento != null
    ? props.procesosDelElemento
    : procesosDelElementoInject.value || [],
);
// Sólo se permiten varias bobinas de extrusión cuando es el único proceso del elemento.
const extrusionEsUnicoProceso = computed(() => (procesosDelElemento.value?.length ?? 0) <= 1);

// COTI-642: ¿este es el proceso de menor orden del elemento? Si lo es, "Proceso inicial" va
// siempre en true y deshabilitado (es la raíz del flujo por definición).
const esPrimerProceso = computed(
  () => !!localModel.value?._uid && procesosDelElemento.value?.[0]?._uid === localModel.value._uid,
);

const IsProcesoExtrusion = computed(() => localModel.value.Proceso?.Codigo === 30);

// COTI-635: la grilla de materiales reales sólo existe en ET y OT — Solicitud
// y Cotización siguen con la grilla plana de siempre (`input-materiales`).
const mostrarMaterialesReales = computed(
  () => (Number(props.modulo) & (Modules.ESPECIFICACION_TECNICA | Modules.ORDEN_PRODUCCION)) !== 0,
);

// Inyectar bocas de referencia desde input_suaje (si están disponibles)
const imposicionReferencia = inject(
  'imposicion',
  computed(() => ({ EtiquetasEje: 0, EtiquetasDesarrollo: 0 })),
);

const localModel = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', { ...value });
  },
});

const recursos = ref([]);
const isDraggableActive = ref(false);
const mostrarDrawerSuaje = ref(false);
const bobinasModalVisible = ref(false);
let dragActivationTimer = null;

const startDragActivation = () => {
  dragActivationTimer = setTimeout(() => {
    isDraggableActive.value = true;
    dragActivationTimer = null;
  }, 200);
};

const cancelDragActivation = () => {
  if (dragActivationTimer) {
    clearTimeout(dragActivationTimer);
    dragActivationTimer = null;
  }
  isDraggableActive.value = false;
};
const filtrosSuaje = computed(() => {
  const filtros = {
    CodigoSuajeTipo: { valor: 'plano', deshabilitado: true },
    EtiquetasEje: { valor: imposicionReferencia.value.EtiquetasEje, visible: false },
    EtiquetasDesarrollo: { valor: imposicionReferencia.value.EtiquetasDesarrollo, visible: false },
  };
  if (recursoSeleccionadoCompleto.value) {
    filtros.CodigoRecurso = { valor: recursoSeleccionadoCompleto.value, deshabilitado: true };
  }
  return filtros;
});

const admiteSuaje = computed(() => {
  const proceso = localModel.value.Proceso;
  if (!proceso) return false;
  return proceso.ProcesoElementoTipo?.AdmiteSuaje;
});

const handleSeleccionarSuaje = (suaje) => {
  emit('update:modelValue', {
    ...localModel.value,
    CodigoSuaje: suaje.Codigo,
    Suaje: suaje,
    BocasAncho: suaje.EtiquetasEje,
    BocasLargo: suaje.EtiquetasDesarrollo,
  });
};

const limpiarSuaje = () => {
  emit('update:modelValue', {
    ...localModel.value,
    CodigoSuaje: null,
    Suaje: null,
    BocasAncho: null,
    BocasLargo: null,
  });
};

const recursoSeleccionadoCompleto = computed(() => {
  const valorRecurso = localModel.value.Recurso;
  if (!valorRecurso) return null;

  if (typeof valorRecurso === 'object' && 'Codigo' in valorRecurso) {
    return valorRecurso;
  }

  const idSeleccionado = Number(valorRecurso);
  if (isNaN(idSeleccionado)) return null;

  const rec = recursos.value.find((r) => r.Codigo === idSeleccionado);
  return rec || null;
});

// Máximo de cuerpos impresores del recurso elegido (sólo impresoras); null = sin límite (12).
const maxCuerposImpresores = computed(() => {
  const recurso = recursoSeleccionadoCompleto.value;
  if (!esRecursoImpresora(recurso?.RecursoTipo)) return null;
  return recurso.CantidadCuerposImpresores ?? null;
});

// COTI-635: código del recurso elegido en pantalla. Se toma del valor de `Recurso` (objeto o id) y
// no de `recursoSeleccionadoCompleto` para no marcar "pendiente" mientras `recursos` no cargó.
const codigoRecursoSeleccionado = computed(() => {
  const valorRecurso = localModel.value.Recurso;
  if (!valorRecurso) return null;
  if (typeof valorRecurso === 'object') return valorRecurso.Codigo ?? null;
  const id = Number(valorRecurso);
  return Number.isNaN(id) ? null : id;
});

// COTI-635: unidad de medida del recurso elegido; el hijo la usa para mostrar la necesidad.
const unidadRecurso = computed(() => {
  const recursoTipo = recursoSeleccionadoCompleto.value?.RecursoTipo;
  const codigo = recursoTipo?.UnidadMedida?.Codigo ?? recursoTipo?.CodigoUnidadMedida ?? null;
  if (codigo == null) return null;
  return {
    Codigo: Number(codigo),
    Abreviatura: recursoTipo?.UnidadMedida?.Abreviatura ?? '',
    Descripcion: recursoTipo?.UnidadMedida?.Descripcion ?? '',
  };
});

// COTI-635: el recurso elegido difiere del último guardado, así que las filas por unidad que
// se muestran corresponden al recurso anterior. Un proceso sin guardar (sin Codigo) no se marca.
const recursoPendienteRecalculo = computed(
  () =>
    !!localModel.value.Codigo &&
    codigoRecursoSeleccionado.value !== (localModel.value._CodigoRecursoPersistido ?? null),
);

// COTI-502: Determinar label para polimero
const labelTotalPolimeros = computed(
  () => resolverLabelsMatrizImpresion(recursoSeleccionadoCompleto.value?.RecursoTipo).total,
);

const factorMultiplicacion = computed(() => {
  const codigoRecursoTipo = recursoSeleccionadoCompleto.value?.CodigoRecursoTipo;
  const recursosTipo = localModel.value.ExtrusionTipo?.RecursosTipo;
  if (!codigoRecursoTipo || !recursosTipo?.length) return 1;
  const rel = recursosTipo.find((r) => r.CodigoRecursoTipo === codigoRecursoTipo);
  return rel?.FactorMultiplicacion ?? 1;
});

/**
 * Determina si el recurso seleccionado opera por golpes (ciclos discretos).
 * Retorna true si la unidad de medida del recurso es "Golpes".
 */
const recursoOperaPorGolpes = computed(() => {
  if (!recursoSeleccionadoCompleto.value) return false;

  const unidadMedida = recursoSeleccionadoCompleto.value.RecursoTipo?.UnidadMedida?.Abreviatura;
  if (!unidadMedida) return false;

  // Normalizar para comparación (case-insensitive, sin espacios)
  const unidadNormalizada = unidadMedida.toLowerCase().trim();

  return unidadNormalizada === 'gol';
});

/**
 * Determina si se deben mostrar los campos de bocas.
 * Prioridad 1: Si el recurso opera por golpes, siempre mostrar
 * Prioridad 2: Si no, usar el flag del proceso (bitfield)
 */
const deberMostrarCamposBocas = computed(() => {
  return (
    recursoOperaPorGolpes.value ||
    !!(localModel.value?.Proceso?.BocasAncho || localModel.value?.Proceso?.BocasAlto)
  );
});

/**
 * Watcher que asigna valores por defecto a BocasAncho y BocasLargo
 * cuando se selecciona un recurso que opera por golpes.
 * Los valores por defecto provienen de EtiquetasEje y EtiquetasDesarrollo del suaje.
 */
watch(recursoOperaPorGolpes, (operaPorGolpes) => {
  if (!operaPorGolpes) return;

  // Solo asignar si los campos están vacíos
  const necesitaAsignarAncho = !localModel.value.BocasAncho || localModel.value.BocasAncho === 0;
  const necesitaAsignarLargo = !localModel.value.BocasLargo || localModel.value.BocasLargo === 0;

  if (necesitaAsignarAncho || necesitaAsignarLargo) {
    const inmutable = { ...localModel.value };

    if (necesitaAsignarAncho && imposicionReferencia.value.EtiquetasEje > 0) {
      inmutable.BocasAncho = imposicionReferencia.value.EtiquetasEje;
    }
    if (necesitaAsignarLargo && imposicionReferencia.value.EtiquetasDesarrollo > 0) {
      inmutable.BocasLargo = imposicionReferencia.value.EtiquetasDesarrollo;
    }
    emit('update:modelValue', inmutable);
  }
});

const alertaInconsistenciaRecurso = computed(() => {
  if (!esProcesoTintas.value || !recursoSeleccionadoCompleto.value) return null;

  const valorColores = recursoSeleccionadoCompleto.value.Colores;
  if (valorColores === null || valorColores === undefined) return null;

  const limite = Number(valorColores);
  const catTinta = localModel.value.CategoriasMaterial.find((c) => {
    const cod = Number(c.Codigo || c.CodigoCategoria || c.CodigoCategoriaMaterial || 0);
    return cod === 7 || cod === 8;
  });

  if (!catTinta || !Array.isArray(catTinta.ElementoMateriales)) return null;

  const filasReales = catTinta.ElementoMateriales.length;

  if (filasReales > limite) {
    return {
      titulo: 'Exceso de Colores',
      mensaje: `La máquina seleccionada permite ${limite} colores, pero hay ${filasReales} items cargados en la grilla. Elimine los sobrantes o cambie de máquina.`,
    };
  }

  return null;
});

const esProcesoTintas = computed(() => {
  const p = localModel.value.Proceso;
  if (!p) return false;

  // const tieneFlagColores = !!p.Colores
  // if (!tieneFlagColores) return false

  const rels = p.ProcesoElementoTipoCategoriaMaterial || [];
  const definicionTieneTinta = rels.some((r) => {
    const cod = r.CodigoCategoriaMaterial || (r.CategoriaMaterial ? r.CategoriaMaterial.Codigo : 0);
    return cod === 7 || cod === 8;
  });

  if (definicionTieneTinta) return true;
  const categoriasActuales = localModel.value.CategoriasMaterial || [];
  const modeloTieneTinta = categoriasActuales.some((c) => {
    const cod = Number(c.Codigo || c.CodigoCategoria || c.CodigoCategoriaMaterial || 0);
    return cod === 7 || cod === 8;
  });

  return modeloTieneTinta;
});

const configuracionesPorDefectoStore = useConfiguracionesPorDefectoStore();
const {
  coberturaTintaPorProceso,
  coberturaBarnizPorProceso,
  tipoTintaDefectoPorProceso,
  tintaDefectoPorProceso,
  barnizDefectoPorProceso,
} = storeToRefs(configuracionesPorDefectoStore);
const { habilitarNuevaGrillaCostos } = storeToRefs(useConfiguracionStore());
const esCotizacion = computed(() => Number(props.modulo) === Modules.COTIZACION);

const crearObjetoTintaBase = (lado) => {
  const tintaDefecto = tintaDefectoPorProceso.value(localModel.value.Proceso?.Codigo);
  return {
    CuerpoImpresor: null,
    CodigoTinta: tintaDefecto?.Codigo ?? 2,
    CodigoTintaTipo: tipoTintaDefectoPorProceso.value(localModel.value.Proceso?.Codigo),
    Cobertura: coberturaTintaPorProceso.value(localModel.value.Proceso?.Codigo) ?? 50,
    LadoAplicacion: lado,
    MatrizAdicional: 0,
    CodigoColor: null,
    Material: tintaDefecto
      ? camposTintaPorDefecto(tintaDefecto).Material
      : {
          Codigo: 2,
          DescripcionInterna: 'Tinta Generica',
          Activo: true,
          MaterialTipo: {
            Codigo: 41,
            Descripcion: 'Tinta',
            MaterialCategoria: { Codigo: 7, Descripcion: 'Tinta' },
          },
        },
    AtributosAdicionales: {},
    EsNuevo: true,
  };
};

const handleGenerarTintas = () => {
  if (!localModel.value.CategoriasMaterial || !Array.isArray(localModel.value.CategoriasMaterial)) {
    console.error('ERROR: No existe el array CategoriasMaterial en el modelo.');
    return;
  }

  // 1. Buscar la categoría Tinta (7) o Serigrafía (8)
  const indexCat = localModel.value.CategoriasMaterial.findIndex((c) => {
    const cod = Number(c.Codigo || c.CodigoCategoria || c.CodigoCategoriaMaterial || 0);
    return cod === 7 || cod === 8;
  });

  if (indexCat === -1) {
    console.warn(
      'ADVERTENCIA: No se encontró la categoría Tintas (7) o Serigrafía (8) en este proceso.',
    );

    return;
  }

  const categoriaTarget = { ...localModel.value.CategoriasMaterial[indexCat] };
  const materialesActuales = categoriaTarget.ElementoMateriales || [];

  const getLado = (m) => String(m.LadoAplicacion || '').toLowerCase();

  const frentes = materialesActuales.filter(
    (m) => getLado(m) === 'frente' || m.LadoAplicacion === 1,
  );
  const liners = materialesActuales.filter((m) => getLado(m) === 'liner' || m.LadoAplicacion === 2);
  const adhesivos = materialesActuales.filter(
    (m) => getLado(m) === 'adhesivo' || m.LadoAplicacion === 3,
  );

  const nuevosMateriales = [];

  const asignarCuerpoAuto = materialesActuales.length === 0;

  const cantFrente = Number(localModel.value.CantidadColoresFrente || 0);
  for (let i = 0; i < cantFrente; i++) {
    const mat = frentes[i] ? frentes[i] : crearObjetoTintaBase('Frente');
    if (asignarCuerpoAuto && !frentes[i]) {
      mat.CuerpoImpresor = getNextCuerpoImpresor(nuevosMateriales, maxCuerposImpresores.value);
    }
    nuevosMateriales.push(mat);
  }

  const cantLiner = Number(localModel.value.CantidadColoresLiner || 0);
  for (let i = 0; i < cantLiner; i++) {
    const mat = liners[i] ? liners[i] : crearObjetoTintaBase('Liner');
    if (asignarCuerpoAuto && !liners[i]) {
      mat.CuerpoImpresor = getNextCuerpoImpresor(nuevosMateriales, maxCuerposImpresores.value);
    }
    nuevosMateriales.push(mat);
  }

  const cantAdhesivo = Number(localModel.value.CantidadColoresAdhesivo || 0);
  for (let i = 0; i < cantAdhesivo; i++) {
    const mat = adhesivos[i] ? adhesivos[i] : crearObjetoTintaBase('Adhesivo');
    if (asignarCuerpoAuto && !adhesivos[i]) {
      mat.CuerpoImpresor = getNextCuerpoImpresor(nuevosMateriales, maxCuerposImpresores.value);
    }
    nuevosMateriales.push(mat);
  }

  categoriaTarget.ElementoMateriales = nuevosMateriales;
  localModel.value.CategoriasMaterial[indexCat] = categoriaTarget;

  localModel.value = { ...localModel.value };
};

const materialCategoryFrom = (em) => {
  return Number(
    em?.Material?.MaterialTipo?.CodigoMaterialCategoria ??
      em?.Material?.MaterialTipo?.Codigo ??
      em?.CategoriaCodigo ??
      em?.CodigoCategoria ??
      0,
  );
};

const procesoTieneMaterialDeCategoria = (catCode) => {
  const rootList = Array.isArray(localModel.value?.ElementoMateriales)
    ? localModel.value.ElementoMateriales
    : [];
  const hitRoot = rootList.some((em) => materialCategoryFrom(em) === Number(catCode));

  if (hitRoot) return true;
  const cats = Array.isArray(localModel.value?.CategoriasMaterial)
    ? localModel.value.CategoriasMaterial
    : [];

  return cats.some((cat) => {
    const list = Array.isArray(cat?.ElementoMateriales) ? cat.ElementoMateriales : [];
    return list.some((em) => materialCategoryFrom(em) === Number(catCode));
  });
};

const shouldHideCategoria = (categoria) => {
  const sectionIs1 = Number(props.zoneId) === 1;
  if (!sectionIs1) return false;

  const code = Number(categoria?.Codigo ?? categoria?.CodigoCategoria ?? 0);
  if (code === MaterialCategoria.ANILOX)
    return procesoTieneMaterialDeCategoria(MaterialCategoria.ANILOX);
  if (code === MaterialCategoria.CINTA_BIFAZ)
    return procesoTieneMaterialDeCategoria(MaterialCategoria.CINTA_BIFAZ);
  return false;
};

const maquinaModel = computed({
  get: () => {
    return {
      Recurso: localModel.value.Recurso || null,
      PorcentajeMerma: localModel.value.PorcentajeMerma || 0,
      Velocidad: localModel.value.Velocidad || null,
    };
  },
  set: (value) => {
    emit('update:modelValue', {
      ...localModel.value,
      Recurso: value.Recurso,
      PorcentajeMerma: value.PorcentajeMerma,
      Velocidad: value.Velocidad,
    });
  },
});

const markAsDeleted = () => {
  // Crear un nuevo objeto con spread para forzar reactividad
  emit('update:modelValue', {
    ...localModel.value,
    MarcadoParaEliminacion: true,
  });
};

const undoDelete = () => {
  // Crear un nuevo objeto con spread para forzar reactividad
  emit('update:modelValue', {
    ...localModel.value,
    MarcadoParaEliminacion: false,
  });
};

// Parsear AtributosJson/AtributosAdicionales para el v-model del componente de atributos
const parseAtributosJson = (atributosData) => {
  if (!atributosData) return {};
  if (typeof atributosData === 'object') return atributosData;
  if (typeof atributosData === 'string') {
    try {
      return JSON.parse(atributosData);
    } catch (e) {
      console.error('Error parseando atributos:', e);
      return {};
    }
  }
  return {};
};

// Manejar actualización de atributos dinámicos
const handleAtributosUpdate = (newValue) => {
  const updatedModel = { ...localModel.value };
  updatedModel.AtributosAdicionales = newValue;
  // Eliminar AtributosJson para evitar duplicación
  delete updatedModel.AtributosJson;
  emit('update:modelValue', updatedModel);
};

const isExtrusionTipoDisabled = (extrusionTipo) => {
  if (!(localModel.value.Recurso?.Codigo > 0)) return false;
  const recurso = recursoSeleccionadoCompleto.value;
  if (!recurso) return false;
  const compatibles = extrusionTipo.RecursosTipo ?? [];
  if (compatibles.length === 0) return false;
  return !compatibles.some((r) => r.CodigoRecursoTipo === recurso.CodigoRecursoTipo);
};

const isMaquinaDisabled = (recurso) => {
  if (!IsProcesoExtrusion.value) return false;

  const extrusionTipo = localModel.value.ExtrusionTipo;
  const cantidadCapas = localModel.value.CantidadCapas || 0;

  if (extrusionTipo?.Codigo) {
    const compatibles = extrusionTipo.RecursosTipo ?? [];
    if (compatibles.length > 0) {
      const esCompatible = compatibles.some(
        (r) => r.CodigoRecursoTipo === recurso.CodigoRecursoTipo,
      );
      if (!esCompatible) return true;
    }
  }

  if (cantidadCapas > 0 && recurso.TornillosMaximos != null) {
    if (recurso.TornillosMaximos < cantidadCapas) return true;
  }

  return false;
};

const recursoSeleccionadoIncompatible = computed(() => {
  if (!localModel.value.Recurso?.Codigo) return false;
  const recurso = recursoSeleccionadoCompleto.value;
  if (!recurso) return false;
  return isMaquinaDisabled(recurso);
});

/**
 * COTI-633: el tamaño del pliego del elemento (inyectado por el *_offset.vue padre, ver
 * `margenesPliego`) no puede superar el ancho/largo máximo de la máquina seleccionada en
 * este proceso, cuando esa máquina mide en Pliego. Espejo del aviso que ya se muestra
 * debajo de las medidas del pliego en input_suaje — este vive junto al selector de
 * máquina para que sea fácil ubicar cuál proceso tiene la máquina que no entra.
 */
const margenesPliego = inject(
  'margenesPliego',
  computed(() => ({ AnchoItem: 0, LargoItem: 0 })),
);

const recursoMideEnPliego = computed(() => {
  const abreviatura = recursoSeleccionadoCompleto.value?.RecursoTipo?.UnidadMedida?.Abreviatura;
  return !!abreviatura && abreviatura.toLowerCase().trim() === 'pl';
});

const erroresMaximoMaquinaPliegoProceso = computed(() => {
  if (!recursoMideEnPliego.value) return { ancho: null, largo: null };

  const anchoItem = Number(margenesPliego.value.AnchoItem ?? 0);
  const largoItem = Number(margenesPliego.value.LargoItem ?? 0);
  if (anchoItem <= 0 && largoItem <= 0) return { ancho: null, largo: null };

  const recurso = recursoSeleccionadoCompleto.value;
  return calcularErrorMaximoMaquinaPliego({
    anchoPliego: anchoItem,
    largoPliego: largoItem,
    anchoMaximo: Number(recurso?.AnchoMaximo ?? 0),
    largoMaximo: Number(recurso?.LargoMaximo ?? 0),
  });
});

// Texto combinado, solo para la alerta inline junto al selector de máquina — el reporte al
// registro de errores va por separado, abajo, con ancho y largo como fallas independientes.
const errorMaximoMaquinaPliegoProceso = computed(
  () =>
    [erroresMaximoMaquinaPliegoProceso.value.ancho, erroresMaximoMaquinaPliegoProceso.value.largo]
      .filter(Boolean)
      .join('\n') || null,
);

// COTI-633: cada validación se reporta al registro del *_edit.vue ancestro con su
// propia clave (useErrorRegistro se encarga de que no se pisen entre instancias, y de
// desregistrarse sola si este componente se desmonta).
const reportarRecursoIncompatible = useErrorRegistro('recursoIncompatible');
const reportarErrorProporcion = useErrorRegistro('proporcionTornillos');
const reportarErrorMaximoPliegoAncho = useErrorRegistro('maximoMaquinaPliegoAncho');
const reportarErrorMaximoPliegoLargo = useErrorRegistro('maximoMaquinaPliegoLargo');

// Filas de tornillos (materializadas en localModel.ElementoProcesoTornillos según
// CantidadCapas). Recuperadas del merge de develop, que perdió estas declaraciones
// dejando los usos en el template (tornillosFila/totalProporcionTornillos/actualizarTornillo).
const tornillosFila = computed(() => localModel.value.ElementoProcesoTornillos || []);

const totalProporcionTornillos = computed(() => {
  return (localModel.value.ElementoProcesoTornillos || []).reduce(
    (sum, t) => sum + (t.Proporcion || 0),
    0,
  );
});

const actualizarTornillo = (index, campo, valor) => {
  const actuales = { ...localModel.value };
  if (!actuales.ElementoProcesoTornillos) {
    actuales.ElementoProcesoTornillos = [];
  }
  actuales.ElementoProcesoTornillos[index][campo] = valor;
  emit('update:modelValue', actuales);
};

// Todas las resinas cargadas en el proceso, sin importar si viven en la raíz o
// agrupadas por categoría de material.
const materialesDelProceso = computed(() => {
  const raiz = Array.isArray(localModel.value?.ElementoMateriales)
    ? localModel.value.ElementoMateriales
    : [];
  const porCategoria = (
    Array.isArray(localModel.value?.CategoriasMaterial) ? localModel.value.CategoriasMaterial : []
  ).flatMap((cat) => (Array.isArray(cat?.ElementoMateriales) ? cat.ElementoMateriales : []));

  return [...raiz, ...porCategoria];
});

// Densidad estimada del film a partir de las resinas, para cuando el maestro de materiales
// no la trae cargada en el material resultante.
const densidadResinas = computed(() => {
  if (!IsProcesoExtrusion.value) return null;
  return calcularDensidadResinas(tornillosFila.value, materialesDelProceso.value);
});

const errorProporcionTornillos = computed(() => {
  if (!IsProcesoExtrusion.value) return false;
  if (!(localModel.value.Recurso?.Codigo > 0)) return false;
  if (tornillosFila.value.length === 0) return false;
  return totalProporcionTornillos.value !== 100;
});

watch(
  recursoSeleccionadoIncompatible,
  (hayError) => {
    reportarRecursoIncompatible(
      hayError,
      'La máquina seleccionada no soporta la cantidad de capas o el tipo de extrusión configurados. Seleccione otra máquina o ajuste los valores.',
    );
  },
  { immediate: true },
);

watch(
  errorProporcionTornillos,
  (hayError) => {
    reportarErrorProporcion(hayError, 'La proporción de los tornillos debe sumar 100%.');
  },
  { immediate: true },
);

watch(
  () => erroresMaximoMaquinaPliegoProceso.value.ancho,
  (mensaje) => {
    reportarErrorMaximoPliegoAncho(!!mensaje, mensaje ?? '');
  },
  { immediate: true },
);

watch(
  () => erroresMaximoMaquinaPliegoProceso.value.largo,
  (mensaje) => {
    reportarErrorMaximoPliegoLargo(!!mensaje, mensaje ?? '');
  },
  { immediate: true },
);

const fetchRecursos = (codigoProceso) => {
  proceso_service
    .findRecursosByProceso(codigoProceso)
    .then((response) => {
      if (response && response.data) {
        recursos.value = response.data.map((r) => r.Recurso);

        const recursoActual = localModel.value.Recurso;
        const idRecursoActual =
          typeof recursoActual === 'object'
            ? recursoActual?.Codigo
            : recursoActual || localModel.value.CodigoRecurso;
        const recursoAunValido = recursos.value.some((r) => r.Codigo === idRecursoActual);

        let nuevoRecurso = recursoAunValido ? localModel.value.Recurso : null;
        let nuevoCodigoRecurso = recursoAunValido ? localModel.value.CodigoRecurso : null;

        if (!recursoAunValido) {
          let idRecursoConfigurado = null;
          const pet = localModel.value.Proceso?.ProcesoElementoTipo;

          if (pet) {
            if (Array.isArray(pet)) {
              const match =
                pet.find((p) => p.CodigoSeccion === props.zoneId && p.CodigoRecurso) ||
                pet.find((p) => p.CodigoRecurso);
              if (match) idRecursoConfigurado = match.CodigoRecurso;
            } else {
              idRecursoConfigurado = pet.CodigoRecurso;
            }
          }

          const recursoPorDefecto = idRecursoConfigurado
            ? recursos.value.find((r) => r.Codigo === idRecursoConfigurado)
            : null;

          if (recursoPorDefecto) {
            nuevoRecurso = recursoPorDefecto;
            nuevoCodigoRecurso = recursoPorDefecto.Codigo;
          } else if (recursos.value.length === 1 && props.modulo === Modules.COTIZACION) {
            nuevoRecurso = recursos.value[0];
            nuevoCodigoRecurso = recursos.value[0].Codigo;
          }

          emit('update:modelValue', {
            ...localModel.value,
            Recurso: nuevoRecurso,
            CodigoRecurso: nuevoCodigoRecurso,
          });
        }
      }
    })
    .catch((error) => {
      console.error('Error fetching recursos:', error);
    });
};

const etiquetasProceso = computed(() => {
  const etiquetas = localModel.value?.Proceso?.ProcesosEtiquetas;
  if (!etiquetas) return {};

  if (Array.isArray(etiquetas)) {
    return etiquetas.length > 0 ? etiquetas[0] : {};
  }

  return etiquetas;
});

// Watcher para cargar recursos cuando cambie el proceso
watch(
  () => localModel.value.Proceso,
  (newProceso, oldProceso) => {
    if (!newProceso || !newProceso.Codigo) {
      return;
    }

    // Solo reaccionar si el código del proceso realmente cambió
    const oldCodigo = oldProceso?.Codigo;
    const newCodigo = newProceso?.Codigo;

    if (oldCodigo && oldCodigo === newCodigo) {
      // El proceso no cambió realmente, solo se actualizó el objeto padre
      return;
    }

    fetchRecursos(newProceso.Codigo);

    const isProcesoChange = !!oldProceso && oldProceso.Codigo !== newProceso.Codigo;
    const isFirstLoad = !oldProceso;
    if (isProcesoChange && isDraggingGlobal.value) {
      return;
    }

    if (isProcesoChange && localModel.value.CodigoSuaje) {
      const nuevoAdmiteSuaje = newProceso.ProcesoElementoTipo?.AdmiteSuaje === true;
      if (!nuevoAdmiteSuaje) {
        emit('update:modelValue', {
          ...localModel.value,
          CodigoSuaje: null,
          Suaje: null,
          BocasAncho: null,
          BocasLargo: null,
        });
        return;
      }
    }

    if (!newProceso.Material) {
      return;
    }

    const categoriasActuales = Array.isArray(localModel.value?.CategoriasMaterial)
      ? localModel.value.CategoriasMaterial
      : [];

    const rels = Array.isArray(newProceso.ProcesoElementoTipoCategoriaMaterial)
      ? newProceso.ProcesoElementoTipoCategoriaMaterial
      : [];

    const categoriasFromProceso = Array.isArray(newProceso.CategoriasMaterial)
      ? newProceso.CategoriasMaterial
      : [];

    let categoriasGeneradas = null;

    if (categoriasFromProceso.length > 0) {
      categoriasGeneradas = categoriasFromProceso.map((categoria) => ({
        ...categoria,
        ElementoMateriales: Array.isArray(categoria.ElementoMateriales)
          ? categoria.ElementoMateriales
          : [],
      }));
    } else if (rels.length > 0 && categoriasActuales.length > 0) {
      const relsByCat = new Map(
        rels.map((rel) => [
          Number(rel.CodigoCategoriaMaterial || rel.CategoriaMaterial?.Codigo || 0),
          rel,
        ]),
      );

      categoriasGeneradas = categoriasActuales.map((cat) => {
        const codCat = Number(
          cat.Codigo ?? cat.CodigoCategoria ?? cat.CodigoCategoriaMaterial ?? 0,
        );
        const rel = relsByCat.get(codCat);

        if (!rel) return { ...cat };

        return {
          ...cat,
          MultiMaterial:
            typeof cat.MultiMaterial === 'boolean' ? cat.MultiMaterial : !!rel.MultiMaterial,
        };
      });
    } else if (rels.length > 0 && categoriasActuales.length === 0) {
      categoriasGeneradas = rels.map((rel) => ({
        Codigo: rel.CategoriaMaterial?.Codigo,
        Descripcion: rel.CategoriaMaterial?.Descripcion,
        Activo: rel.CategoriaMaterial?.Activo,
        Modulo: rel.CategoriaMaterial?.Modulo,
        MultiMaterial: !!rel.MultiMaterial,
        ValidaAnchoMaterial: rel.CategoriaMaterial?.ValidaAnchoMaterial,
        MaterialCategoriaEtiquetas: rel.CategoriaMaterial?.MaterialCategoriaEtiquetas ?? {},
        ElementoMateriales: [],
      }));
    }

    if (categoriasGeneradas && categoriasGeneradas.length > 0) {
      const tieneMaterialesExistentes = categoriasActuales.some(
        (cat) => Array.isArray(cat.ElementoMateriales) && cat.ElementoMateriales.length > 0,
      );
      let categoriasFinal = categoriasGeneradas;

      if (tieneMaterialesExistentes) {
        categoriasFinal = categoriasGeneradas.map((catGen) => {
          const codGen = Number(
            catGen.Codigo ?? catGen.CodigoCategoria ?? catGen.CodigoCategoriaMaterial ?? 0,
          );
          const catActual = categoriasActuales.find(
            (cat) =>
              Number(cat.Codigo ?? cat.CodigoCategoria ?? cat.CodigoCategoriaMaterial ?? 0) ===
              codGen,
          );

          if (!catActual) return catGen;

          return {
            ...catActual,
            MultiMaterial:
              typeof catActual.MultiMaterial === 'boolean'
                ? catActual.MultiMaterial
                : catGen.MultiMaterial,
            ValidaAnchoMaterial: catGen.ValidaAnchoMaterial ?? catActual.ValidaAnchoMaterial,
            MaterialCategoriaEtiquetas:
              catGen.MaterialCategoriaEtiquetas ?? catActual.MaterialCategoriaEtiquetas,
          };
        });
      }

      nextTick(() => {
        emit('update:modelValue', {
          ...localModel.value,
          CategoriasMaterial: categoriasFinal,
        });
      });
    }
  },
  {
    immediate: true,
  },
);

// Al cambiar de proceso, las filas de tinta ya creadas conservan el tipo del proceso anterior:
// se les aplica el default del proceso nuevo (sin pisar un tipo elegido a mano).
watch(
  () => localModel.value.Proceso?.Codigo,
  async (codigoNuevo, codigoAnterior) => {
    if (!codigoNuevo || !codigoAnterior || codigoNuevo === codigoAnterior) return;
    // El watcher de `Proceso` (arriba) re-emite `CategoriasMaterial` en un nextTick a partir de
    // una copia previa: se espera a que termine para leer el modelo ya actualizado y no perder el cambio.
    await nextTick();
    await nextTick();
    const categorias = localModel.value.CategoriasMaterial;
    const conTipoActualizado = reasignarTipoTintaPorCambioDeProceso(
      categorias,
      tipoTintaDefectoPorProceso.value(codigoAnterior),
      tipoTintaDefectoPorProceso.value(codigoNuevo),
    );
    const conTintaActualizada = reasignarTintaPorCambioDeProceso(
      conTipoActualizado,
      tintaDefectoPorProceso.value(codigoAnterior),
      tintaDefectoPorProceso.value(codigoNuevo),
    );
    const conBarnizActualizado = reasignarBarnizPorCambioDeProceso(
      conTintaActualizada,
      barnizDefectoPorProceso.value(codigoAnterior),
      barnizDefectoPorProceso.value(codigoNuevo),
    );
    const actualizadas = reasignarCoberturaPorCambioDeProceso(conBarnizActualizado, {
      tinta: {
        anterior: coberturaTintaPorProceso.value(codigoAnterior) ?? 50,
        nuevo: coberturaTintaPorProceso.value(codigoNuevo) ?? 50,
      },
      barniz: {
        anterior: coberturaBarnizPorProceso.value(codigoAnterior) ?? 100,
        nuevo: coberturaBarnizPorProceso.value(codigoNuevo) ?? 100,
      },
    });
    if (actualizadas === categorias) return;
    emit('update:modelValue', { ...localModel.value, CategoriasMaterial: actualizadas });
  },
);

watch(
  () => localModel.value.Proceso?.Codigo,
  (codigo) => {
    if (!codigo) return;
    if (!IsProcesoExtrusion.value) return;
    if (localModel.value.CantidadCapas > 0) return;
    emit('update:modelValue', { ...localModel.value, CantidadCapas: 1 });
  },
  { immediate: true },
);

// Materializa las filas reales de ElementoProcesoTornillos según CantidadCapas,
// preservando los valores ya cargados (proporción / material resultante).
const sincronizarFilasTornillos = (cantidad) => {
  const existentes = Array.isArray(localModel.value.ElementoProcesoTornillos)
    ? localModel.value.ElementoProcesoTornillos
    : [];
  if (existentes.length === cantidad) return;
  const filas = [];
  for (let i = 0; i < cantidad; i++) {
    filas.push(existentes[i] || { Proporcion: null, CodigoMaterialMezcla: null });
  }
  emit('update:modelValue', { ...localModel.value, ElementoProcesoTornillos: filas });
};

watch(
  () => localModel.value.CantidadCapas,
  (cantidad) => {
    if (!IsProcesoExtrusion.value) return;
    sincronizarFilasTornillos(Number(cantidad) || 0);
  },
  { immediate: true },
);

// Al seleccionar un material resultante con fórmula, se autocompletan capas/tornillos
// y los materiales componentes de cada mezcla. De entrada solo aplica si aún no se
// cargaron tornillos; con `reemplazar` (el usuario confirmó el cambio de resultante en el
// modal) se pisa lo que hubiera.
const tornillosSinCargar = () => {
  const tornillos = localModel.value.ElementoProcesoTornillos || [];
  const hayTornilloConDatos = tornillos.some((t) => t?.CodigoMaterialMezcla || t?.Proporcion);
  if (hayTornilloConDatos) return false;
  const categorias = localModel.value.CategoriasMaterial || [];
  return !categorias.some((c) => (c.ElementoMateriales || []).some((r) => r.NumeroTornillo));
};

const tieneFormulaCargada = computed(() => IsProcesoExtrusion.value && !tornillosSinCargar());

const precargarTornillosDesdeFormula = async (
  codigoMaterial,
  { reemplazar = false, formulas: formulasPrecargadas = null } = {},
) => {
  try {
    let formulas = formulasPrecargadas;
    if (!formulas) {
      const response = await MaterialService.findByCode(codigoMaterial);
      formulas = response?.data?.MaterialFormula;
    }
    // Sin fórmula no hay con qué reemplazar: se deja lo que el usuario tenga cargado.
    if (!formulas?.length) return;
    if (!reemplazar && !tornillosSinCargar()) return;

    const tornillos = formulas.map((f, i) => ({
      ItemTornillo: i + 1,
      Proporcion: f.Proporcion ?? null,
      CodigoMaterialMezcla: f.CodigoMaterialFormula ?? null,
      MaterialMezcla: f.MaterialComponente
        ? {
            Codigo: f.MaterialComponente.Codigo,
            DescripcionInterna: f.MaterialComponente.DescripcionInterna,
          }
        : null,
    }));

    // Atributos físicos del componente que la grilla de resinas puede mostrar como columnas
    // dinámicas (Densidad, etc.). Se copian a nivel fila —que es lo que bindea la grilla via
    // row[col.prop]— y dentro de Material por consistencia.
    const PHYS_ATTRS = [
      'Densidad',
      'Espesor',
      'Gramaje',
      'Ancho',
      'Alto',
      'Largo',
      'Diametro',
      'Rendimiento',
    ];

    // Componentes de la fórmula de cada mezcla (la fórmula del resultante trae un solo nivel)
    const filasPorTornillo = await Promise.all(
      formulas.map(async (f, i) => {
        if (!f.CodigoMaterialFormula) return [];
        try {
          const res = await MaterialService.findByCode(f.CodigoMaterialFormula);
          const componentes = res?.data?.MaterialFormula || [];
          return componentes
            .filter((c) => c.CodigoMaterialFormula)
            .map((c) => {
              const comp = c.MaterialComponente;
              const row = {
                Material: comp
                  ? { Codigo: comp.Codigo, DescripcionInterna: comp.DescripcionInterna }
                  : {},
                Porcentaje: c.Proporcion ?? 0,
                NumeroTornillo: i + 1,
                MaterialTipoConfig: {},
              };
              if (comp) {
                PHYS_ATTRS.forEach((attr) => {
                  if (comp[attr] !== undefined && comp[attr] !== null) {
                    row[attr] = comp[attr];
                    row.Material[attr] = comp[attr];
                  }
                });
              }
              return row;
            });
        } catch {
          return [];
        }
      }),
    );
    const filas = filasPorTornillo.flat();

    // Al reemplazar se descartan las resinas de la fórmula anterior (las que están
    // asignadas a un tornillo); el resto de los materiales del proceso queda intacto.
    const categorias = (localModel.value.CategoriasMaterial || []).map((c) =>
      reemplazar
        ? {
            ...c,
            ElementoMateriales: (c.ElementoMateriales || []).filter((r) => !r.NumeroTornillo),
          }
        : { ...c },
    );
    const idxCat = categorias.findIndex((c) => {
      const cod = Number(c.Codigo || c.CodigoCategoria || c.CodigoCategoriaMaterial || 0);
      return c.Modulo && cod !== 7 && cod !== 8;
    });
    const asignaFilas = idxCat >= 0 && filas.length > 0;
    if (asignaFilas) {
      categorias[idxCat] = {
        ...categorias[idxCat],
        ElementoMateriales: [...(categorias[idxCat].ElementoMateriales || []), ...filas],
      };
    }

    emit('update:modelValue', {
      ...localModel.value,
      CantidadCapas: formulas.length,
      ElementoProcesoTornillos: tornillos,
      // Al reemplazar hay que emitir las categorías aunque no haya filas nuevas que
      // asignar: si no, las resinas viejas que se filtraron arriba quedarían vivas.
      ...(asignaFilas || reemplazar ? { CategoriasMaterial: categorias } : {}),
    });
  } catch (e) {
    console.error('Error precargando la fórmula del material resultante', e);
  }
};

watch(
  () => localModel.value.CodigoMaterialResultante,
  (codigo, codigoAnterior) => {
    if (!codigo || codigo === codigoAnterior) return;
    if (!IsProcesoExtrusion.value) return;
    if (!tornillosSinCargar()) return;
    precargarTornillosDesdeFormula(codigo);
  },
);

// El usuario confirmó el cambio de material resultante en el modal: se rehacen capas,
// proporciones, materiales mezcla y resinas con la fórmula del material nuevo.
const onReemplazarFormula = async ({ codigoMaterial, formulas }) => {
  if (!codigoMaterial) return;
  // El evento llega junto con el update:modelValue del material nuevo. Sin esperar al
  // próximo tick, la precarga partiría de un localModel viejo y pisaría el material recién
  // elegido al re-emitir el modelo completo.
  await nextTick();
  precargarTornillosDesdeFormula(codigoMaterial, { reemplazar: true, formulas });
};

// Cargar recursos al montar el componente
onMounted(() => {
  if (localModel.value.Proceso && localModel.value.Proceso.Codigo) {
    fetchRecursos(localModel.value.Proceso.Codigo);
  }

  // Convertir AtributosJson a AtributosAdicionales si existe
  if (localModel.value.AtributosJson && !localModel.value.AtributosAdicionales) {
    const parsed = parseAtributosJson(localModel.value.AtributosJson);
    const updatedModel = { ...localModel.value };
    updatedModel.AtributosAdicionales = parsed;
    delete updatedModel.AtributosJson;
    emit('update:modelValue', updatedModel);
  }
});

onUnmounted(() => {
  if (dragActivationTimer) {
    clearTimeout(dragActivationTimer);
  }
});

const shouldShowPorcentaje = computed(() => {
  const proceso = localModel.value.Proceso;
  if (!proceso) return false;
  if (IsProcesoExtrusion.value) return false;

  return !!proceso.Porcentaje;
});

const handleDragStart = (event) => {
  // AHORA sí activar isDraggingGlobal porque el drag realmente comenzó
  isDraggingGlobal.value = true;

  event.dataTransfer.setData('text/plain', props.index.toString());
  event.dataTransfer.setData('zone-id', props.zoneId.toString());
  event.dataTransfer.effectAllowed = 'move';
  emit('drag-start', { index: props.index, zoneId: props.zoneId, event });
};

const handleDragEnd = (event) => {
  if (dragActivationTimer) {
    clearTimeout(dragActivationTimer);
    dragActivationTimer = null;
  }
  // Desactivar isDraggingGlobal inmediatamente
  isDraggingGlobal.value = false;
  isDraggableActive.value = false;
  emit('drag-end', { index: props.index, event });
};
</script>

<style scoped>
.custom-label {
  font-weight: 700;
  color: #111;
}

/* Estilo para campos con error de porcentaje */
.error-porcentaje :deep(.el-input__wrapper) {
  border-color: #f56c6c !important;
  box-shadow: 0 0 0 1px #f56c6c inset !important;
}

.error-porcentaje :deep(.el-input__inner) {
  border-color: #f56c6c !important;
}

.error-porcentaje :deep(.el-input-number__decrease),
.error-porcentaje :deep(.el-input-number__increase) {
  border-color: #f56c6c !important;
}

/* COTI-633: una línea por mensaje (ancho/largo) cuando ambos aplican a la vez. */
.alerta-margenes-pliego :deep(.el-alert__title) {
  white-space: pre-line;
}

.row-proceso {
  align-items: flex-end;
}

.row-observaciones {
  margin-top: 8px;
}

.draggable-item-setion {
  cursor: move;
  transition: all 0.2s ease;
  padding: 8px;
  display: flex;
  align-items: center;
  user-select: none;
}

.draggable-item-setion:hover {
  background-color: #e8f4fd;
  border-radius: 4px;
}

.draggable-item-setion:active {
  background-color: #d0e8f7;
}

.draggable-item:hover {
  background-color: #f5f7fa;
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.draggable-item.dragging {
  opacity: 0.5;
  transform: rotate(2deg);
}

.deleted-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(245, 247, 250, 0.7);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: grayscale(100%) blur(1px);
}

.deleted-content {
  background-color: white;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid #dcdfe6;
}

.deleted-text {
  color: #909399;
  font-weight: bold;
  font-style: italic;
}
</style>
